import { OfferHandleMode } from "./order";
import {PaginationResponse} from "./paginationResponse";
import {AdminPromoCodeUsage} from "./promoCode";

export interface AdminUserInfo {
    id: bigint
    image: string
    userName: string
    role: string
    isOnline: boolean
    tradingEnabled: boolean
    hasBan: boolean
    isAccessBlacklisted?: boolean
    created: Date
    lastActivityAt: Date
    name?: string
    rub: number
}

export interface AdminUserStatisticInfo {
    id: bigint
    buyingAmount: number
    salesAmount: number
    depositAmount: number
    withdrawalAmount: number
    deliverySpeed?: number
    totalSuccess: number
    totalFailures: number
    rub: number
}

export interface AdminUserBalanceHistory {
    date: Date
    value: number
}

export interface ApiBanInfo {
    createdAt: Date
    gameName: string | undefined
}

export interface AdminUserFullInfo extends AdminUserStatisticInfo, AdminUserInfo {
    bans: ApiBanInfo[] | undefined,
    SteamApiKey?: string,
    apiKey?: string,
    tradeLink?: string,
    sessionToken?: string,
    soundNotification: boolean,
    webPushNotification: boolean,
    offerHandleMode?: OfferHandleMode,
    offerHandleDelaySeconds?: number,
    bidingEnabled: boolean,
    level?: number,
    isPublicProfile: boolean,
    offlineBidsEnabled: boolean,
    /** Промокоды пользователя, новые сверху (статус показывает активный и израсходованный) */
    promoCodes?: AdminPromoCodeUsage[]
}

export interface AdminUserInfoResult extends PaginationResponse<AdminUserInfo> {}

export interface AdminUserStatisticInfoResult extends PaginationResponse<AdminUserStatisticInfo> {}

export interface InventorySkinInfoResult extends PaginationResponse<InventorySkinInfo> {}

export interface InventorySkinInfo {
    skinId: string,
    status: SkinStatus,
    createdAt: Date,
    onSoldAt?: Date,
    reservedAt?: Date,
    onHoldUntil?: Date,
    name: string,
    hashName: string,
    type: string,
    subType?: string,
    image?: string,
    steamPrice?: number,
    price?: number,
    toDelete: boolean,
    inspectLink?: string,
    orderId?: number
}

export enum SkinStatus {
    None = 0,
    OnSold = 1,
    Reserved = 2,
    OnPause = 3
}

export const SkinStatusName = {
    0: 'Не установлен',
    1: 'В продаже',
    2: 'Зарезервирован',
    3: 'На паузе'
}

export interface AdminUserPenaltyInfo {
    totalPenaltyPoints: number
    activePenaltyPoints: number
    isTradingBlocked: boolean
    tradingBlockUntil?: Date
}

export interface AdminUserPenaltyHistory {
    id: number
    points: number
    description?: string
    orderId?: number
    created: Date
}

export interface GetPenaltyHistoryRequest {
    page: number
    count: number
    dateRange?: {
        min?: Date
        max?: Date
    }
}

export interface AdminUserSessionIpRow {
    id: number
    ip: string
    start: Date
    lastActivity: Date
}

export interface AdminUserSessionRow {
    id: number
    created: Date
    lastActivity: Date
    fingerprint?: string
    isActive: boolean
    ips: AdminUserSessionIpRow[]
}

export interface AdminUserSessionsResponse extends PaginationResponse<AdminUserSessionRow> {}

export interface AdminSessionIpsResponse {
    sessionId: number
    userId: bigint
    items: AdminUserSessionIpRow[]
}

// Funds buckets (available-to-withdraw details)
export enum FundsBucketType {
    Deposit = 0,
    Sale = 1
}

export const FundsBucketTypeName: Record<number, string> = {
    [FundsBucketType.Deposit]: 'Депозит',
    [FundsBucketType.Sale]: 'Выручка от продажи'
};

export interface AdminUserFundsBucketRow {
    type: FundsBucketType
    amountTotal: number
    amountUsed: number
    lockUntil?: Date
    created: Date
}

export namespace SkinId  {
    const regex = new RegExp('^(?<gameId>\\d+)_(?<steamId>\\d+)_(?<assetId>\\d+)_?(?<index>\\d+)?$');

    export function assetId(skinId: string): string {
        let result = regex.exec(skinId);
        return result?.groups?.assetId ?? 'noid';
    }
}